import http from '@/http'

const API_PATH = 'organizations/:organizationId/users/:userId/user_private_chat_status'

const configureApiPath = ({ organizationId, userId }) => {
  return API_PATH.replace(':organizationId', organizationId)
                 .replace(':userId', userId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async update({ commit, rootGetters }, payload) {
    const { userId, attributes } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      userId: userId
    })
    const params = JSON.stringify({
      userPrivateChatStatus: attributes
    })
    await http.put(apiPath, params).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
